import { useEffect, useState } from 'react';

import { Button } from '@mui/material';
import axios, { AxiosError, AxiosResponse } from 'axios';
import { useSnackbar } from 'notistack';

import strings from 'constants/index';
import { useDialogStatus } from 'hooks/common';
import { formatError } from 'utils/request.utils';

import { FixtureCompetitorCollisionDialog } from './FixtureCompetitorCollisionDialog';

export const FixtureCompetitorCollision = ({ onClick }) => {
  const [error, setError] = useState(null);
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();
  const { isOpen, onShow, onHide } = useDialogStatus();

  useEffect(() => {
    const interceptor = axios.interceptors.response.use(
      async (response: AxiosResponse) => {
        if (
          response.config.url === '/fixtures' &&
          (response.config.method === 'post' || response.config.method === 'put')
        ) {
          onHide();
          setError(null);
        }
        return response;
      },
      async (error: AxiosError) => {
        const message = formatError(error);
        if (
          (error?.response?.status === 400 &&
            message.startsWith(strings.fixture_competitors_400_error)) ||
          (error?.response?.status === 409 &&
            message.startsWith(strings.fixture_competitors_409_error))
        ) {
          setError(message);
          onShow();
        } else if (!axios.isCancel(error)) {
          enqueueSnackbar(message, {
            variant: 'error',
            autoHideDuration: null,
            action: key => (
              <Button color="inherit" onClick={() => closeSnackbar(key)}>
                {strings.dismiss}
              </Button>
            ),
          });
        }

        return Promise.reject(error);
      },
    );

    return () => {
      axios.interceptors.response.eject(interceptor);
      onHide();
    };
  }, [closeSnackbar, enqueueSnackbar, onHide, onShow]);

  return (
    isOpen && (
      <FixtureCompetitorCollisionDialog
        isOpen={isOpen}
        onHide={onHide}
        message={error}
        onClick={onClick}
      />
    )
  );
};
